import type { components } from "@/api/types";

export type CommentItem = components["schemas"]["CommentItem"];
export type CommentReply = components["schemas"]["CommentReply"];
export type CommentAuthor = components["schemas"]["CommentAuthor"];
export type CommentSort = components["schemas"]["CommentSort"];
export type CommentReportReason = components["schemas"]["CommentReportReason"];
export type CommentsSummary = components["schemas"]["CommentsSummary"];

/** Порядок вкладок §6.1: «Полезные / Новые / С высокой оценкой». */
export const COMMENT_SORTS = ["helpful", "new", "top_rated"] as const satisfies readonly CommentSort[];

export const REPORT_REASONS = [
  "spam",
  "abuse",
  "scam",
  "offtopic",
  "other",
] as const satisfies readonly CommentReportReason[];

/** Предел из контракта. Дублируется здесь, чтобы счётчик поля знал его до ответа сервера. */
export const COMMENT_MAX_LENGTH = 2000;
